import { render } from "./HeroIcon.vue?vue&type=template&id=61f8d495"
import script from "./HeroIcon.vue?vue&type=script&lang=js"
export * from "./HeroIcon.vue?vue&type=script&lang=js"
script.render = render

export default script